/** A compact ownership mark drawn in Harborline's visual language. */
export function VeteranOwnedMark() {
  return (
    <div className="veteran-owned-mark" role="img" aria-label="Veteran-Owned Small Business">
      <svg
        className="veteran-owned-mark-icon"
        viewBox="0 0 48 48"
        role="presentation"
        aria-hidden="true"
      >
        <path
          d="M24 3.5 38 8.4v10.8c0 10.1-5.4 18.2-14 24.6-8.6-6.4-14-14.5-14-24.6V8.4L24 3.5Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinejoin="round"
        />
        <path
          d="m24 10.2 2.15 4.35 4.8.7-3.48 3.39.82 4.78L24 21.17l-4.29 2.25.82-4.78-3.48-3.39 4.8-.7L24 10.2Z"
          fill="currentColor"
        />
        <path d="M16.5 29.5h15M18.6 34h10.8" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
      </svg>
      <span className="veteran-owned-mark-copy">
        <strong>Veteran-Owned</strong>
        <span>Small Business</span>
      </span>
    </div>
  )
}
